import React from 'react'
import style from "./Register.module.css"

const Register = () => {
  return (
    <div style={{ flex: 1 }}>
      <div className={style.landing_container}></div>
      
    </div>
  )
}

export default Register